import React from "react";
import { CommunityInfo } from "./DashboardSearchFooterStyle";
import { useNavigate } from "react-router-dom";

const DashboardSearchFooter = () => {
  let navigate = useNavigate();

  return (
    <CommunityInfo>
      <p>찾으시는 꽃이 없나요?</p>
      <p>커뮤니티에 질문/문의를 남겨 주세요!</p>
      <button onClick={() => navigate(`/boards`)}>커뮤니티 바로가기</button>
    </CommunityInfo>
  );
};

export default DashboardSearchFooter;
